import React from 'react';
import { Tag } from 'antd';
import { ToolOutlined, CloudOutlined } from '@ant-design/icons';

const EnvironmentBadge = ({ isLocal }) => {
  return isLocal ? (
    <Tag icon={<ToolOutlined />} color="blue">
      Local Dev
    </Tag>
  ) : (
    <Tag icon={<CloudOutlined />} color="green">
      AWS Production
    </Tag>
  );
};

export default EnvironmentBadge;
